// src/db/db-context.js
import React, { createContext } from 'react';
import { taketrainingDb, checktrainingsDb, updatedProgDb, pretestDb, quizDb, modalTriggeredDB } from './Index';  // Import the actual database instance

// Create the context
export const DbContext = createContext();

// Create the provider
export const DbProvider = ({ children }) => {
  return (
    <DbContext.Provider value={{taketrainingDb, checktrainingsDb, updatedProgDb, pretestDb, quizDb, modalTriggeredDB}}>
      {children}
    </DbContext.Provider>
  );
};
